import { Charts } from "./Charts";
import { RevenuePrices } from "./RevenuePrices";
import { TemplateColors, Templates } from "./Templates";

/**Data grids used on revenue price application */
export class DataGrids
{
	private _parent: RevenuePrices;
	private _charts: Charts;

	/**
	 * Constructor for data grids used in revenue price application
	 * @param parent parent object that runs the application
	 * @param charts chart object that handles operations around the chart
	 */
	constructor(parent: RevenuePrices, charts: Charts)
	{
		this._parent = parent;
		this._charts = charts;
	}

	/**Setup Desktop Price data grid */
	SetupPriceDetails ()
	{
		$('#' + Templates.Ids.gridContainer).dxDataGrid({
			dataSource: this._parent.sharedDataSource,
			wordWrapEnabled: true,
			columns: [
				{ dataField: "commodity", caption: "Crop", allowFiltering: true },
				{
					dataField: "type", caption: "Type", allowFiltering: false,
					cellTemplate: (container, options) =>
					{
						if (options.data.type.split(',').length > 1 || options.data.type.length > 8)
						{
							$("<div id= " + options.data.groupId + 1 + " >")
								.append(this.CleanTrimString(options.data.type.split(',')[0]) + "&nbsp;<b>...</b><div id=" + options.data.groupId + ">")
								.appendTo(container);

							$("#" + options.data.groupId).dxTooltip({
								target: "#" + options.data.groupId + 1,
								showEvent: {
									name: "dxhoverstart dxclick"
								},
								hideEvent: "dxhoverend",
								position: "right",
								contentTemplate: function (contentElement)
								{
									contentElement.html("<div>" + options.data.type.replace(/,/g, '<br>') + "</div>");
								}
							});
						} else
						{
							$("<div>")
								.append(options.data.type)
								.appendTo(container);
						}
					}
				},
				{ dataField: "practice", caption: "Practice", allowFiltering: false },
				{
					dataField: "salesClosingDate", caption: "Sales Close", allowFiltering: false,
					customizeText: (data) =>
					{
						if (data.valueText != undefined)
						{
							return data.valueText.replace(/^0/, '');
						}

						return "";
					}
				},
				{
					dataField: "baseExchange", caption: "Exchange", allowFiltering: false
				},
				{
					dataField: "basePrice.priceDisplayString",
					caption: "Projected Price",
					allowFiltering: false,
					cellTemplate: (container, options) =>
					{
						if (options.data.basePrice.discoveryTimingDescription != "")
						{
							let toolTipDiv = $("<div id=" + options.data.groupId + "PROJECTEDTIP" + ">");

							$("<div id= " + options.data.groupId + "PROJECTED" + " >")
								.append(this.CleanTrimString(options.data.basePrice.priceDisplayString + "&nbsp;"))
								.append(toolTipDiv)
								.appendTo(container);

							toolTipDiv.dxTooltip({
								target: "#" + options.data.groupId + "PROJECTED",
								showEvent: {
									name: "dxhoverstart dxclick"
								},
								hideEvent: "dxhoverend",
								position: "right",
								contentTemplate: function (contentElement)
								{
									contentElement.html("<div>" + options.data.basePrice.discoveryTimingDescription + "</div>");
								}
							});
						} else
						{
							$("<div>")
								.append(options.data.basePrice.priceDisplayString)
								.appendTo(container);
						}						
					}
				},
				{
					dataField: "harvestPrice.priceDisplayString",
					caption: "Harvest Price",
					allowFiltering: false,
					cellTemplate: (container, options) =>
					{
						if (options.data.harvestPrice.discoveryTimingDescription != "")
						{
							let toolTipDiv = $("<div id=" + options.data.groupId + "HARVESTTIP" + ">");

							$("<div id= " + options.data.groupId + "HARVEST" + " >")
								.append(this.CleanTrimString(options.data.harvestPrice.priceDisplayString + "&nbsp;<div id=" + options.data.groupId + "HARVESTTIP" + ">"))
								.append(toolTipDiv)
								.appendTo(container);

							toolTipDiv.dxTooltip({
								target: "#" + options.data.groupId + "HARVEST",
								showEvent: {
									name: "dxhoverstart dxclick"
								},
								hideEvent: "dxhoverend",
								position: "right",
								contentTemplate: function (contentElement)
								{
									contentElement.html("<div>" + options.data.harvestPrice.discoveryTimingDescription + "</div>");
								}
							});
						} else
						{
							$("<div>")
								.append(options.data.harvestPrice.priceDisplayString)
								.appendTo(container);
						}
					}					
				},
				{
					dataField: "volatilityDisplayString",
					caption: "Volatility", allowFiltering: false
				},
				{
					cellTemplate: (container, options) =>
					{
						let $button = $("<button type='button' class='.btn-default'>Details</button>").click(() =>
						{
							this._parent.ShowChartClick(options.data);
						});

						$("<div style='text-align: center'>")
							.append($button)
							.appendTo(container);
					}
				}],
			// Disabling the default load panel, as we are using the NAU loading modal
			loadPanel: { enabled: false },
			onDataErrorOccurred: this.DefaultDataErrorOccured,
			rowAlternationEnabled: true,
			// Currently for unknown reasons font icons are not being properly loaded via the CDN
			"export": {
				enabled: false,
				fileName: "Price_Definition"

			},
			columnChooser: {
				enabled: false,
				mode: "select"
			},
			cacheEnabled: true,
			noDataText: "Unfortunately we have no price definitions for the current selections."
		});
		// Chaining to prevent multiple data calls
		this.SetupMobilePriceDetails();
	}

	/**Setup Mobile Price List */
	SetupMobilePriceDetails ()
	{
		$('#' + Templates.Ids.simpleList).dxList({
			dataSource: $('#gridContainerDiv').dxDataGrid("instance").getDataSource(),
			height: "100%",
			itemTemplate: (items) =>
			{
				var result = $("<div>").addClass("mobileCard");
				// The button id is generated to allow identification/record opening on pageload from query string parameter
				var infoColumn = $("<div class ='row' id='Button" + items.groupId + "'>");
				infoColumn.click(() =>
				{
					this._parent.ShowChartClick(items);
				});

				var infoBase = $("<div>").addClass("col-xs-11");

				$("<h4>").text(items.commodity).appendTo(infoBase);
				$("<div>").text(items.practice).appendTo(infoBase);
				$("<div>").text(items.salesClosingDate).appendTo(infoBase);
				infoBase.appendTo(infoColumn);

				var caretBase = $("<div>").addClass("col-xs-1");
				$("<span class='fonticon-right-arrow'></span >").appendTo(caretBase);
				caretBase.appendTo(infoColumn);
				infoColumn.appendTo(result);

				return result;
			},
			indicateLoading: false,
			pageLoadingText: '',
			pageLoadMode: 'scrollBottom',
			noDataText: "Unfortunately we have no price definitions for the current selections.",
			onContentReady: () =>
			{
				// When content is ready and if the modal ID is set, so on a page load typically we can auto display the dialog
				this._parent.ShowChartModalFromQueryStringValue();
			}
		}).dxList("instance");
	}

	/**
	 * Setup Modal Price Data Grid
	 * @param basePriceSource data source for grid
	 */
	SetupModalPrice (basePriceSource)
	{
		// Setup Price Grid
		$('#' + Templates.Ids.popupGridBasePriceDiv).dxDataGrid({
			dataSource: basePriceSource,
			columns: [{ dataField: "dateOfPrice", caption: "Date" },
			{
				dataField: "closingPriceDisplayString", caption: "Ending"

			},
			{
				width: 75,
				cellTemplate: (container, options) => {
					this.PriceTemplate(container, options, this);
				}
			}
			],
			paging: { pageSize: 6 },
			rowAlternationEnabled: true,
			noDataText: "No Price data available.",
			onDataErrorOccurred: this.DefaultDataErrorOccured
		});
	}

	/**
	 * Setup Modal Harvest Price Data Grid
	 * @param harvestPriceSource data source for grid
	 */
	SetupModalHarvestPrice (harvestPriceSource)
	{
		// Setup Harvest Price Grid
		$('#' + Templates.Ids.popupGridHarvestPriceDiv).dxDataGrid({
			dataSource: harvestPriceSource,
			columns: [
				{ dataField: "dateOfPrice", caption: "Date" },
				{
					// Changed to closing price for Bug 97192 which was for soybeans.  This should be correct for all crops and types, 
					// but making note of change in case another bug comes in to switch this back to opening for something else.
					dataField: "closingPriceDisplayString", caption: "Price"
				},
				{
					width: 75,
					cellTemplate: (container, options) =>
					{
						this.PriceTemplate(container, options, this);
					}
				}
			],
			paging: { pageSize: 6 },
			rowAlternationEnabled: true,
			noDataText: "No Harvest Price data available.",
			onDataErrorOccurred: this.DefaultDataErrorOccured
		});
	}

	private PriceTemplate(container, options, self: DataGrids)
	{
		var sparkData =
			[{
				"stack": "Opening Price",
				"value": options.data.openingPrice
			}, {
				"stack": "Highest Price",
				"value": options.data.highPrice
			}, {
				"stack": "Lowest Price",
				"value": options.data.lowPrice
			}, {
				"stack": "Closing Price",
				"value": options.data.closingPrice
			}];

		container.addClass("chart-cell");

		$("<div/>").dxSparkline({
			dataSource: sparkData,
			argumentField: "stack",
			valueField: "value",
			type: "spline",
			showMinMax: true,
			minColor: TemplateColors.nauOrange,
			maxColor: TemplateColors.nauBlue,
			pointSize: 2,
			size: {
				width: 50,
				height: 25
			},
			tooltip: {
				enabled: true,
				customizeTooltip: function (info)
				{
					return {
						html:
							"<div><div class='tooltip-body'><div class='value-text'>" +
							self._charts.SparkLineTooltip(info.valueText) +
							" </div></div></div>"
					};
				}
			}
		}).appendTo(container);
	}

	private DefaultDataErrorOccured(info)
	{
		window.NauUtility.errorOps.handleFatalError(new Error("Unable to load data: " + info + '\'.'));

	}

	/**
	 * Trimming string at space before 8 characters for display purposes
	 * @param input object to trim
	 */
	private CleanTrimString(input)
	{
		return input.replace(/^(.{8}[^\s]*).*/, "$1");
	}
}